module.exports = __webpack_public_path__ + "img/warning_otp.e9bd35c1.svg";